module.exports = __webpack_public_path__ + "img/byte.2abdd420.svg";